module.exports = __webpack_public_path__ + "img/DE00374.6809492c.png";